import React from 'react'
import PropTypes from 'prop-types'

const ProgressBarSecurity = (props) => {
    const getBg = () => {
        if (props.progress < 60) return 'bg-red'
        if (props.progress < 80) return 'bg-yellow'

        return ''
    }

    return (
        <div className='bar-chart'>
            <div className={`progress ${getBg()}`} style={{ width: `${Math.min(props.progress, 100)}%` }} />
        </div>
    )
}

ProgressBarSecurity.propTypes = {
    progress: PropTypes.number.isRequired
}

export default ProgressBarSecurity



// WEBPACK FOOTER //
// ./resources/js/elements/ProgressBarSecurity.js